<template>
  <v-card class="pa-4">
    <v-dialog v-model="confirmDialog" max-width="300">
      <v-card class="pa-4 text-center">
        <h3>Atenção!</h3>
        <p v-if="model.institutionId != institutionId">
          Esse processo alienará todos os equipamentos selecionados na
          instituição de origem e criará estes registros na instituição
          selecionada como destino.
        </p>
        <p>Tem certeza de que deseja transferir estes equipamentos?</p>

        <div class="d-flex justify-center">
          <v-btn
            depressed
            color="primary"
            class="ma-1"
            @click="confirmDialog = false"
            >Voltar</v-btn
          >
          <v-btn depressed color="secondary" class="ma-1" @click="submit"
            >Prosseguir</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <h2 class="mb-5 text-center">Transferência de Equipamentos</h2>

    <v-form ref="form">
      <v-row class="ma-0" dense>
        <v-col cols="12">
          <strong>Destino:</strong>
        </v-col>
        <v-col cols="12" sm="6">
          <label class="label">{{ $t('Instituição') }}</label>
          <v-autocomplete
            v-model="model.institutionId"
            append-icon="mdi-chevron-down"
            outlined
            class="primary-input"
            hide-details="auto"
            :items="institutions"
            item-text="name"
            item-value="id"
            :loading="institutionLoading"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            @change="getUnits"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6">
          <label class="label">{{ $t('Unidade') }}</label>
          <v-autocomplete
            v-model="model.unitId"
            :disabled="!model.institutionId"
            append-icon="mdi-chevron-down"
            outlined
            class="primary-input"
            hide-details="auto"
            :items="unidades"
            item-text="name"
            item-value="id"
            :loading="unidadeLoading"
            :rules="[(v) => !!v || 'Campo obrigatório']"
            @change="setDepartments"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6">
          <label class="label">{{ $t('Setor') }}</label>
          <v-autocomplete
            v-model="model.departmentId"
            :disabled="!model.unitId"
            append-icon="mdi-chevron-down"
            outlined
            class="primary-input"
            hide-details="auto"
            :items="localDepartments"
            item-text="name"
            item-value="id"
            :loading="departmentLoading"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6">
          <label class="label">{{ $t('Sub-setor') }}</label>
          <v-autocomplete
            v-model="model.subDepartmentId"
            :disabled="!model.departmentId"
            label=""
            append-icon="mdi-chevron-down"
            outlined
            class="primary-input"
            hide-details="auto"
            :items="subDepartments"
            item-text="name"
            item-value="id"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12">
          <label class="label">{{ $t('Data da migração') }}</label>
          <div class="d-flex">
            <date-picker
              ref="datepicker"
              style="width: 100%"
              v-model="model.date"
              mode="dateTime"
              is24hr
              :popover="{ visibility: 'click' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :class="dateError ? 'date-input-error' : 'date-input'"
                  :value="inputValue"
                  v-on="inputEvents"
                  v-mask="['##/##/#### ##:##']"
                  @focus="setDate"
                />
                <span class="date-span-error" v-if="dateError">
                  {{ $t('Data da solicitação é requerida') }}
                </span>
              </template>
            </date-picker>
          </div>
        </v-col>
        <v-col cols="12">
          <label class="label">{{ $t('Motivo da migração') }}</label>
          <v-textarea
            v-model="model.reason"
            outlined
            class="primary-input"
            hide-details="auto"
            :rules="[(v) => !!v || 'Campo obrigatório']"
          ></v-textarea>
        </v-col>
        <v-col cols="12">
          <div class="d-flex justify-center mt-4">
            <v-btn
              depressed
              color="primary"
              class="ma-1"
              @click="$emit('cancel')"
              >Cancelar</v-btn
            >
            <v-btn depressed color="secondary" class="ma-1" @click="confirm">
              Transferir
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
export default {
  name: 'TransferComponent',

  props: {
    selectedEquipments: Array,
  },

  data() {
    return {
      model: {
        date: null,
      },
      dateError: false,
      confirmDialog: false,
      apiService: new ApiService(),
      institutions: [],
      institutionLoading: false,
      unidades: [],
      unidadeLoading: false,
      departmentLoading: false,
      localDepartments: [],
      userLogged: {},
      institutionId: null,
    }
  },

  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.model.institutionId = this.institutionId

    this.getUnits()
    await this.listInstitutions()
  },

  computed: {
    subDepartments() {
      const departments = this.localDepartments.filter(
        (x) => this.model.departmentId == x.id
      )
      return departments.map((x) => x.subDepartments).flat(1)
    },
  },

  methods: {
    async getUnits() {
      this.model.unitId = null
      this.model.departmentId = null
      this.model.subDepartmentId = null
      this.localDepartments = []

      if (this.institution.userType > 1) {
        await this.getUserUnidades()
      } else {
        await this.getUnidades()
      }
    },

    setDate() {
      this.model.date = this.model.date ? this.model.date : new Date()
    },

    confirm() {
      if (!this.model.date) this.dateError = true

      if (this.$refs.form.validate()) {
        this.confirmDialog = true
      }
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.model.equipmentIds = this.selectedEquipments.map((x) => x.id)
        this.apiService.post('equipment/transfer', this.model).then(() => {
          this.$toast.success('Equipamentos transferidos! Tudo registrado 🔄')
          this.$emit('confirm')
        })
      }
    },

    async setDepartments() {
      this.model.departmentId = null
      this.model.subDepartmentId = null
      this.localDepartments = []

      if (!this.model.unitId) return

      this.departmentLoading = true
      await this.apiService
        .get(`department/list/unidade/${this.model.unitId}`)
        .then((response) => {
          this.localDepartments = response.content
          this.departmentLoading = false
        })
        .catch(() => {
          this.departmentLoading = false
        })
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.model.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.model.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    async listInstitutions() {
      this.institutions = []
      this.institutionLoading = true
      await this.apiService
        .get('institution/ListUser')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch((err) => {
          this.institutionLoading = false
        })
    },
  },
}
</script>

<style scoped>
.date-input {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 1px solid #707070 !important;
  padding-left: 10px !important;
}

.date-input-error {
  background: var(--primary-input-background) !important;
  font-family: var(--primary-input-font) !important;
  font-size: var(--primary-input-font-size) !important;
  font-weight: var(--primary-input-font-weigth) !important;
  line-height: var(--primary-input-line-height) !important;
  letter-spacing: var(--primary-input-letter-spacing) !important;
  border-radius: var(--primary-input-border-radius) !important;
  height: 45px;
  width: 100%;
  border: 2px solid #ff5252 !important;
  padding-top: 0 !important;
}
</style>
